import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DateHelper, DateTimeUnit } from '../../../helpers/date.helper';
import { BaseModalDialogDirective } from '../../../directives/base-modal-dialog.directive';

export enum ManualQuarantineType {
  ForTime = 'ForTime',
  UntilDateTime = 'UntilDateTime',
  UntilMidnight = 'UntilMidnight',
  Manual = 'Manual',
}

@Component({
  selector: 'app-quarantine-modal',
  templateUrl: './quarantine-modal.component.html',
  styleUrl: './quarantine-modal.component.scss',
  standalone: false,
})
export class QuarantineModalComponent extends BaseModalDialogDirective implements OnInit {
  @Input() title: string;
  @Input() entityName: string;
  @Input() isQuarantined = false;
  @Input() endOfQuarantine: Date;

  readonly ManualQuarantineType = ManualQuarantineType;
  readonly DateTimeUnit = DateTimeUnit;

  minDate = new Date();
  form = this.formBuilder.group({
    type: [ManualQuarantineType.Manual],
    duration: [{ value: 3600000, disabled: true }],
    time: [{ value: DateHelper.addTime(new Date(), 1, DateTimeUnit.Hour), disabled: true }],
  });

  get f() {
    return this.form.controls;
  }

  constructor(
    private formBuilder: FormBuilder,
  ) {
    super();
    this.form.controls.type.valueChanges.subscribe((value: ManualQuarantineType) => {
      this.updateFormControls(value);
    });
  }

  ngOnInit(): void {
    if (this.endOfQuarantine != null) {
      this.f.type.setValue(ManualQuarantineType.UntilDateTime);
      this.f.time.setValue(this.endOfQuarantine);
    }
  }

  private updateFormControls(value: ManualQuarantineType): void {
    switch (value) {
      case ManualQuarantineType.ForTime:
        this.f.duration.enable();
        this.f.time.disable();
        break;
      case ManualQuarantineType.UntilDateTime:
        this.f.duration.disable();
        this.f.time.enable();
        break;
      case ManualQuarantineType.UntilMidnight:
      case ManualQuarantineType.Manual:
        this.f.duration.disable();
        this.f.time.disable();
        break;
    }
  }

  setQuarantineManually(): void {
    if (this.form.invalid) {
      return;
    }

    let endOfQuarantine: Date = null;
    const type = this.form.controls.type.value;
    switch (type) {
      case ManualQuarantineType.ForTime: {
        const duration = this.form.controls.duration?.value;
        endOfQuarantine = DateHelper.addTime(new Date(), duration, DateTimeUnit.Millisecond);
        break;
      }
      case ManualQuarantineType.UntilDateTime: {
        const time = this.form.controls.time?.value;
        endOfQuarantine = new Date(time);
        break;
      }
      case ManualQuarantineType.UntilMidnight:
        endOfQuarantine = DateHelper.endOfDay(new Date());
        break;
      default:
        endOfQuarantine = null;
        break;
    }

    this.close({ endOfQuarantine });
  }
}
